import { CLIPPING_DIRECTION } from '@interlayer/js/components/tagTypes/buzz/TopMenu/constants';

export const getClippingDirection = (element: HTMLElement | null): CLIPPING_DIRECTION => {
    if (!element) {
        return CLIPPING_DIRECTION.unknown;
    }

    const rect = element.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;

    if (rect.right >= viewportWidth) {
        return CLIPPING_DIRECTION.right;
    }

    if (rect.left <= 0) {
        return CLIPPING_DIRECTION.left;
    }

    return CLIPPING_DIRECTION.unknown;
};
